import { resolveProjectEnvVar } from '@cli-utils/files.js'
import { isValidDbUrl } from './is-valid-db-url.js'

export function readExistingDbUrl(cwd: string): ReturnType<typeof resolveProjectEnvVar> {
  const resolved = resolveProjectEnvVar(cwd, 'DATABASE_URL')
  if (!resolved) return undefined

  const value = resolved.value.trim()
  if (value.startsWith('your_') || value === 'postgresql://...' || !isValidDbUrl(value)) {
    return undefined
  }

  return { ...resolved, value }
}
